import { appAPI, ApiMethods } from '.';

interface TrackPageViewInput {
  eventType: 'PAGE_VIEWED#INC';
  eventData: {
    page: string;
  };
}

type GetRecentlyVisitedResponse = {
  Crm: Array<{
    clientId: string;
  }>;
  Apps: Array<{
    moduleExtensionConfigId: string;
  }>;
};

export const analyticsApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    trackPageView: build.mutation<void, TrackPageViewInput>({
      query: (body) => ({
        method: ApiMethods.post,
        options: { body },
        path: '/v1/analytics/track',
      }),
    }),
    getRecentlyVisitedApps: build.query<GetRecentlyVisitedResponse, void>({
      query: () => ({
        path: `/v1/analytics-recently-visited`,
        method: ApiMethods.get,
        options: {},
      }),
    }),
  }),
});

export const { useTrackPageViewMutation, useGetRecentlyVisitedAppsQuery } =
  analyticsApi;
